import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useSelector } from "react-redux"
import { toast } from "sonner"
import { selectCurrentOrganizationId } from "@/modules/organizations/store/organizationSlice"
import type { RootState } from "@/store"
import type { CreateIncreasePeriodRequest } from "../dtos/IncreasePeriodDto"
import { getApiErrorMessage } from "../infrastructure/api-error"
import { salaryIncreaseService } from "../infrastructure/salary-increase-service"

const FALLBACK_ERROR = "Could not open the period"

export function useCreateIncreasePeriod() {
  const queryClient = useQueryClient()
  const organizationId = useSelector((s: RootState) =>
    selectCurrentOrganizationId(s),
  )

  return useMutation({
    mutationFn: (request: CreateIncreasePeriodRequest) => {
      if (!organizationId) throw new Error("No organisation selected")
      return salaryIncreaseService.createIncreasePeriod(organizationId, request)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["increase-periods"] })
      toast.success("Period opened — Remco approval captured")
    },
    onError: (error) => toast.error(getApiErrorMessage(error, FALLBACK_ERROR)),
  })
}
